import moment from 'moment';
import * as dateFormat from '@/helpers/dateFormat';
import { FreezeStatus, FREEZE_STATUS_VIEW, FREEZE_DATE_FORMAT } from '@/helpers/freeze';

/** Siralama ham degerler uzerinden: tarih kolonu metni DD.MM.YYYY'ye gore dizilmesin. */
const sortValue = (row, key) => (row[key] instanceof Date ? row[key].getTime() : row[key]);

const compareValues = (a, b) => {
  if (typeof a === 'number' && typeof b === 'number') {
    return a - b;
  }
  // Aciklama bos gelebilir; localeCompare null uzerinde patlardi.
  return String(a == null ? '' : a).localeCompare(String(b == null ? '' : b));
};

export default {

  data() {
    return {
      freezeList: [],
      // Yalnizca basarili yuklemeden sonra true: hata durumunda "freeze yok" yazmak yanlis olurdu.
      isLoaded: false,
      currentSort: 'StartDate',
      currentSortDir: 'asc',
      pageSize: 6,
      currentPage: 1,
    };
  },
  async mounted() {
    try {
      const response = await this.$globalApiClient.freeze.freezeGetUpcoming();
      if (!response.data.IsSuccess) {
        toastr.error(response.data.Message ? response.data.Message : 'Error');
        return;
      }
      // Kalan sure yukleme anina gore hesaplaniyor; durum (Planlandi/Yururlukte) da sunucunun
      // o anki saatine gore geldigi icin ikisi birlikte tazelenir.
      const now = moment();
      this.freezeList = (response.data.Data || []).map((item) => {
        // Tarihler duvar saati; bkz. dateFormat.parseWallClock.
        const startDate = dateFormat.parseWallClock(item.StartDate);
        const endDate = dateFormat.parseWallClock(item.EndDate);
        const isActive = item.Status === FreezeStatus.Active;
        const view = FREEZE_STATUS_VIEW[item.Status];
        return {
          ...item,
          StartDate: startDate,
          EndDate: endDate,
          StartDateText: startDate ? moment(startDate).format(FREEZE_DATE_FORMAT) : '',
          EndDateText: endDate ? moment(endDate).format(FREEZE_DATE_FORMAT) : '',
          IsActive: isActive,
          StatusText: view ? this.translate(view.label) : '',
          StatusBadge: view ? view.badge : '',
          // Yururlukteki donem icin bitisine, planlanmis donem icin baslamasina kalan sure.
          RemainingText: this.remainingText(isActive ? endDate : startDate, now,
            isActive ? 'freeze_ends_in' : 'freeze_starts_in'),
        };
      });
      this.isLoaded = true;
    } catch (e) {
      // 401 ve 403 OtherApis'teki ortak yakalayicida zaten isleniyor.
      if (e && e.statusCode !== 401 && e.statusCode !== 403) {
        toastr.error(typeof e.message === 'string' ? e.message : 'Error');
      }
    }
  },
  methods: {
    redraw() {},
    /**
     * 'Bitisine 3 Gun' / 'Baslamasina 5 Saat'. Bir gunun altinda saat gosterilir; bir saatin
     * altinda da '1 Saat' yazar, '0 Saat' donemin coktan basladigini/bittigini dusundururdu.
     * Hedef gecmisteyse (istemci ile sunucu saati arasindaki fark) bos kalir.
     */
    remainingText(target, now, key) {
      if (!target) {
        return '';
      }
      const end = moment(target);
      if (!end.isValid() || !end.isAfter(now)) {
        return '';
      }
      const days = end.diff(now, 'days');
      const amount = days >= 1
        ? `${days} ${this.translate('day')}`
        : `${Math.max(1, end.diff(now, 'hours'))} ${this.translate('hour')}`;
      return this.translate(key).replace('{0}', amount);
    },
    sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
    },
    nextPage() {
      if (this.currentPage * this.pageSize < this.freezeList.length) this.currentPage++;
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
  },
  computed: {
    sortedFreezeList() {
      const direction = this.currentSortDir === 'asc' ? 1 : -1;
      const start = (this.currentPage - 1) * this.pageSize;
      // slice(): veri dizisi computed icinde yerinde siralanmasin.
      return this.freezeList.slice()
        .sort((a, b) => direction * compareValues(sortValue(a, this.currentSort), sortValue(b, this.currentSort)))
        .slice(start, start + this.pageSize);
    },
    isLastPage() {
      return this.currentPage * this.pageSize >= this.freezeList.length;
    },
    isFirstPage() {
      return this.currentPage === 1;
    },
  },
};
